import BaseStore from '@/js/core/BaseStore';
import { WorkTypes } from '@/utils/Enums';
import { IWorkTypeStore } from './WorkTypeTypes';
import WorkTypeService from '../services/WorkTypeService';

const workTypeStore = {
	workTypes: [],
};

class WorkTypesStore extends BaseStore<IWorkTypeStore, WorkTypeService> {
	async fetchWorkTypes() {
		const { data } = await this.service.fetchWorkTypes();
		this.state.workTypes = data.result;
	}

	mapOptionsForOnboarding(): { name: string; value: string }[] {
		return this.state?.workTypes.map((item) => {
			switch (item.languages[0].en) {
				case WorkTypes.Permanent:
					return { name: `👔 ${item.name}`, value: item.id };
				case WorkTypes.Contract:
					return { name: `📑 ${item.name}`, value: item.id };
				case WorkTypes.Temporary:
					return { name: `🗓 ${item.name}`, value: item.id };
				case WorkTypes.Freelance:
					return { name: `👩‍💻 ${item.name}`, value: item.id };
				default:
					return { name: item.name, value: item.id };
			}
		});
	}
}

export default new WorkTypesStore(workTypeStore, WorkTypeService);
